<template>
    <div>
        <az-back-button :route="{name: buscarRotaAnterior, params: {id: patrimonioId}}"
                        :text="filtrarRotaAnterior"/>
        <div class="az-form-content">

            <reavaliacao-detalhe-cabecalho
                :reavaliacao="reavaliacao"/>

            <v-divider/>
            <reavaliacao-detalhe-campos
                :reavaliacao="reavaliacao"
                :patrimonio="patrimonio"
                @atualizar="atualizar"
            />

            <reavaliacao-detalhe-patrimonios
                :patrimonio="patrimonio"
                :reavaliacao="reavaliacao"
            />

            <panel-documentos
                ref="panelDocumentos"
                v-if="reavaliacaoId"
                dono-documento="reavaliacao"
                :dono-documento-id="reavaliacaoId"
            />
        </div>
    </div>
</template>

<script>
    import {actionTypes} from '@/core/constants'
    import ReavaliacaoDetalheCabecalho
        from '@/views/pages/patrimonio/reavaliacao/visualizacao/ReavaliacaoDetalheCabecalho.vue'
    import ReavaliacaoDetalheCampos
        from '@/views/pages/patrimonio/reavaliacao/visualizacao/ReavaliacaoDetalheCampos.vue'
    import ReavaliacaoDetalhePatrimonios
        from '@/views/pages/patrimonio/reavaliacao/visualizacao/ReavaliacaoDetalhePatrimonios.vue'
    import {mapActions} from 'vuex'
    import PanelDocumentos from '@/views/components/panel/documentos/PanelDocumentos'

    export default {
        name: 'ReavaliacaoDetalhe',
        components: {
            ReavaliacaoDetalhePatrimonios,
            ReavaliacaoDetalheCampos,
            ReavaliacaoDetalheCabecalho,
            PanelDocumentos
        },
        data() {
            return {
                reavaliacao: {},
                patrimonio: {
                    setor: ''
                },
                rotaOrigem: 'NovaReavaliacao',
                reavaliacaoId: null,
                ehDestinatario: false
            }
        },
        async mounted() {
            await this.setarReavaliacaoId()
            await this.buscarReavaliacao()
            await this.buscarPatrimonio()
        },
        computed: {
            buscarRotaAnterior() {
                if (this.$route.query.rotaOrigem) {
                    return this.$route.query.rotaOrigem
                }
                return 'ReavaliacaoListagem'
            },
            filtrarRotaAnterior() {
                return this.configurarNomeRotaAnterior()
            },
            patrimonioId() {
                if (this.reavaliacao.patrimonio) {
                    return this.reavaliacao.patrimonio.id
                }
                return null
            }
        },
        methods: {
            ...mapActions([
                actionTypes.REAVALIACAO.BUSCAR_REAVALIACAO_POR_ID,
                actionTypes.REAVALIACAO.EDITAR_REAVALIACAO
            ]),
            async buscarReavaliacao() {
                this.reavaliacao = await this.buscarReavaliacaoPorId(this.reavaliacaoId)
            },
            async buscarPatrimonio() {
                this.patrimonio = this.reavaliacao.patrimonio
            },
            configurarNomeRotaAnterior() {
                if (this.buscarRotaAnterior === 'NovaReavaliacao') {
                    return 'Voltar para linha do tempo'
                }
                return 'Voltar para listagem'
            },
            setarReavaliacaoId() {
                this.reavaliacaoId = this.$route.params.reavaliacaoId
            },
            async atualizar(reavaliacao) {
                await this.editarReavaliacao(reavaliacao)
                await this.buscarReavaliacao()
            }
        }
    }
</script>
